/**
 * ref（分支/标签名）可能含 `/`，在 URL path 中用 ~ 表示，避免与 path 混淆。
 * 注意：API 请求仍用 encodeURIComponent(ref)。
 */
export function refToSegment(ref: string): string {
    return ref.replace(/\//g, '~');
}

export function segmentToRef(seg: string): string {
    return seg.replace(/~/g, '/');
}
